export const environment = {
    production: false,
    apiVersion: 'v1',
    apiUrl: 'https://discoveryapi-dev.quiron.digital/api/',
    apiEndpoint: '',
    discoveryApiUrl: 'https://discoveryapi-dev.quiron.digital/api/v1',
    googleClientId: '831681820534-vakqdggpmkpku4cv6vp0tt7sq77ikg2e.apps.googleusercontent.com',
    microsoftClientId: '19288977-7584-4040-b312-fcd090e8621f',
};

environment.apiEndpoint = `${environment.apiUrl}${environment.apiVersion}`;
